export default "/fcbcac1db17390110677298f9d30eeed9c121039/74cc88c7571ddfe8037db442e45677ad.svg";